import React from 'react';

export default function TooYoung() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <span style={styles.icon}>🚫</span>
        <h1 style={styles.title}>Age Restriction</h1>
        <p style={styles.text}>
          Winesup is a wine recommendation service exclusively for adults of legal drinking age.
        </p>
        <p style={styles.text}>
          You must be of legal drinking age in your country of residence to use this service.
          In most countries this is 18 years of age; in the United States it is 21 years of age.
        </p>
        <p style={styles.text}>
          We encourage responsible drinking and are committed to preventing underage access.
        </p>
        <p style={styles.subtext}>
          If you believe this was shown in error, please contact us at{' '}
          <a href="mailto:support@winesup.org">support@winesup.org</a>.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #4a1528 100%)', padding: '20px',
  },
  card: {
    background: '#fff', borderRadius: '12px', padding: '48px', maxWidth: '480px',
    width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  icon: { fontSize: '3rem' },
  title: { fontSize: '1.8rem', color: '#1a1a1a', margin: '16px 0 8px' },
  text: { color: '#555', lineHeight: '1.6', margin: '0 0 16px' },
  subtext: { color: '#888', fontSize: '0.85rem', marginTop: '16px' },
};
